import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { createUserAPI, loginUserAPI } from "../../../../configs/WebService";
import { apiKeyHeader } from "../../../../configs/ApiKeys";

export const signupUser = createAsyncThunk(
  "signup/signupUser",
  async (formData, { rejectWithValue }) => {
    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        contact_number: formData.contact_number,
        password: formData.password,
        source: formData.source,
        city: formData.city,
      };

      console.log("payload", JSON.stringify(payload));

      const response = await axios.post(createUserAPI, payload, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Signup failed";
      return rejectWithValue(message);
    }
  },
);

export const loginUser = createAsyncThunk(
  "signup/loginUser",
  async (formData, { rejectWithValue }) => {
    try {
      const payload = {
        email: formData.email,
        password: formData.password,
      };

      const response = await axios.post(loginUserAPI, payload, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Login failed";
      return rejectWithValue(message);
    }
  },
);
